import * as z from "zod";

export const disconnectLinnworksIntegration = {
  name: "disconnectLinnworksIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
